<template>
	<checkout-block>
		<checkout-block-header>Godkend ordre</checkout-block-header>

		<checkout-block-body>
			<div
				v-if="basket.OrderLines && basket.OrderLines.length > 0"
				class="border border-gray-300 bg-white text-xs sm:text-base text-black p-4 sm:p-8 mt-6"
			>
				<div v-for="(ol, index) in basket.OrderLines" :key="index">
					<div class="text-base">{{ ol.ProductName }}</div>
					<div class="text-gray-800">
						{{ ol.Quantity }} stk. - {{ ol.Total | toCurrency }}
					</div>
				</div>
			</div>

			<hr class="mt-6 border-t border-gray-300" />

			<template v-if="basket.AllowDiscount">
				<form
					@submit.prevent="addDiscount()"
					class="flex mt-6 -mx-2"
					v-if="!basket.HasDiscount && checkoutMode != 'member'"
				>
					<label class="px-2 flex flex-col w-3/4">
						<div class="pb-2 font-bold">Rabatkode</div>
						<div>
							<input
								type="text"
								v-model="discountCode"
								class="input-text w-full"
							/>
						</div>
					</label>

					<div class="w-1/3 pt-8">
						<button
							type="submit"
							class="border-gray-400 border rounded-sm text-red-700 text-tinier sm:text-base inline-flex items-center py-2 px-2 sm:px-4 bg-transparent"
						>
							Indløs <span class="hidden sm:inline">&nbsp;rabatkode</span>
						</button>
					</div>
				</form>

				<div
					v-if="basket.HasDiscount && checkoutMode != 'member'"
					class="mt-6"
				>
					<div class="p-4 bg-green-800 text-white">
						Rabatkode tilføjet
					</div>
				</div>

				<hr class="my-6 border-t border-gray-300" />

			</template>


			<label class="flex flex-col">
				<div class="pb-2"><span class="font-bold">Eventuelle bemærkninger</span> (valgfri)</div>
				<div>
					<textarea
						rows="3"
						v-model="basket.BillingMessage"
						@blur="saveBasket()"
						@keyup="saveBasket()"
						@change="saveBasket()"
						class="input-text w-full"
					/>
				</div>
			</label>

			<label class="flex items-center font-normal mt-6 h-5">
				<input
					type="checkbox"
					class="form-checkbox text-top focus:outline-none w-6 h-6"
					:checked="conditionsAccepted"
					@click="toggleConditionsAccepted"
				/>
				<span class="ml-2">
					Ja, jeg accepterer
					<a :href="termsLink" target="_blank" class="text-top"
						>handelsbetingelserne</a
					>
				</span>

				<div v-if="conditionsAccepted && hasTriedToCheckout" class="ml-4">
					<svg
						width="20"
						height="20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="20" height="20" rx="10" fill="#4E9036" />
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M8.472 12.195L14.667 6l.943.943-7.138 7.138-3.805-3.805.943-.943 2.862 2.862z"
							fill="#fff"
						/>
					</svg>
				</div>
			</label>

			<transition
				enter-active-class="transition-all duration-3s timing-ease"
				leave-active-class="transition-all duration-3s timing-ease"
				enter-class="opacity-0 scale-y-0 -translate-y-full"
				enter-to-class="opacity-1 scale-y-100 translate-y-0"
				leave-class="opacity-1 scale-y-100 translate-y-0"
				leave-to-class="opacity-0 scale-y-0 -translate-y-full"
			>
				<div v-if="hasTriedToCheckout && !conditionsAccepted">
					<div
						class="bg-red-700 inline-block mt-2 text-white p-1 rounded-sm font-normal text-micro sm:text-xs"
					>
						Du skal acceptere handelsbetingelserne
					</div>
				</div>
			</transition>
		</checkout-block-body>
	</checkout-block>
</template>

<script>
import axios from "axios";

export default {
	props: {
		termsLink: String,
		associationGuid: String,
		showDiscountForm: Boolean
	},
	data: function() {
		return {
			discountCode: ""
		};
	},
	computed: {
		hasTriedToCheckout: function() {
			return this.$store.getters.hasTriedToCheckout;
		},
		basket: function() {
			return this.$store.getters.basket;
		},
		checkoutMode: function() {
			return this.$store.getters.checkoutState;
		},
		conditionsAccepted: function() {
			return this.$store.getters.conditionsAccepted;
		}
	},
	methods: {
		saveBasket: function() {
			this.$store.dispatch("saveBasket", this.$store.getters.basket);
		},
		toggleConditionsAccepted: function() {
			this.$store.dispatch("toggleConditionsAccepted");
			setTimeout(() => this.validateAll(), 10);
		},
		addDiscount: function() {
			axios
				.post("/umbraco/Checkout/Basket/AddDiscount", {
					discountCode: this.discountCode,
					associationId: this.associationGuid
				})
				.then(response => {
					if (response.data.Success) {
						this.$store.commit("updateBasket", { basket: response.data.Data });
					} else {
						alert("Rabatkoden kunne ikke tilføjes");
					}
				});
		},
		validateAll: function() {
			if (this.hasTriedToCheckout) {
				this.$store.dispatch("reportValidation", {
					olIndex: "confirm",
					index: "confirm",
					missingFields: !this.conditionsAccepted ? 1 : 0
				});
			}
		}
	},
	mounted: function() {
		this.validateAll();
	},
	watch: {
		hasTriedToCheckout: function() {
			this.validateAll();
		}
	}
};
</script>
